module.exports = __webpack_public_path__ + "img/project15_8.jpeg.c473ff3c.webp";